import GoTop from "@/components/common/cathay-page/goTop";
export default {
  install(Vue, options = {}) {
    Vue.component("GoTop", GoTop);
  }
};

export { GoTop };
